/**
 * @category Home / 0.Top Bar
 * @subcategory KPI
 * @module api-kpi
 */
import { kpiClient } from '@/api/axios';
import type { IGetKPIResp } from '@/types/kpi';

/**
 * @function
 * @async
 * @param {string} agentId agentId
 * @returns {Promise<{getKpiResp: IGetKPIResp}>}
 * @desc Get agent kpi, such as calls handled, missed, and average talk time
 *
 * **Invoked by:**
 * - ##### [setAgentKpiAction() - stores/agent.ts](module-AgentStore.html#~setAgentKpiAction)
 */
export const getKPI = async (
  agentId: string
): Promise<{
  getKpiResp: IGetKPIResp
}> => {
  const { data } = await kpiClient.get<{HistoricalMetrics:IGetKPIResp}>('/metrics/agent', {
    params: {
      agentId
    }
  });

  const { HistoricalMetrics } = data;

  return { getKpiResp: HistoricalMetrics };
};